/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ProfileShowcase_viewer$ref: FragmentReference;
export type ProfileShowcase_viewer = {|
  +tradeProgramsQuery: ?$ReadOnlyArray<?{|
    +iconUri: ?string
  |}>,
  +$refType: ProfileShowcase_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "ProfileShowcase_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "tradeProgramsQuery",
      "storageKey": "tradeProgramsQuery(programCodes:[\"PUBLIC_PROFILE_PUBLISH\"])",
      "args": [
        {
          "kind": "Literal",
          "name": "programCodes",
          "value": [
            "PUBLIC_PROFILE_PUBLISH"
          ],
          "type": "[String]"
        }
      ],
      "concreteType": "LoyaltyProgram",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "iconUri",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '6c40f045d2ad7180df8aae0d720c30d1';
module.exports = node;
